import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DeliveryPaymentStatus, DeliveryPaymentStatusAux, DeliveryStatusAux } from 'src/app/models/delivery.schema';
import { Expert } from 'src/app/models/expert.schema';
import { ServiceModel } from 'src/app/models/service.schems';
import { FormGroupToObject } from 'src/app/pipes/form-group-to-object.pipe';
import { AuthStatusService } from 'src/app/services/auth-status.service';
import { ExpertService } from 'src/app/services/expert.service';
import { Service } from 'src/app/services/service.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { TransactionsService } from 'src/app/services/transactions.service';

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.scss']
})
export class TransactionsComponent implements OnInit {

  groups: any;
  transactionFilterForm: any;
  limit: number;
  page: number;
  count: number = 0;
  maxPage: number;
  order: {};
  selected = "active";
  defaultPage = 1;
  defaultLimit = 50;
  defaultOrder = { 'Transactions.id': 'DESC' };
  filtered = {};
  transactions: any[] = [];
  selectedExpert: Expert;
  experts: Expert[] = [];
  services: ServiceModel[] = [];
  deliveryPaymentStatusAux = DeliveryPaymentStatusAux;
  selectedExpertId: number = null;
  totalCreditAmount: number;

  constructor(
    private authStatusService: AuthStatusService,
    private route: ActivatedRoute,
    private transactionService: TransactionsService,
    private spinnerService: SpinnerService,
    private expertService: ExpertService,
    public service: Service,
    public router: Router,
  ) { 
    this.groups = this.authStatusService.getRoles().map((elem: string) => elem.toLowerCase());
    this.handleFilterForm();
  }

  async ngOnInit() {
    try {
      this.spinnerService.show();
      if(this.groups.includes('expert')){
        let loggedInExpert = JSON.parse(sessionStorage.getItem("currentUser"));
        this.selectedExpert = await this.expertService.getOne(loggedInExpert?.expert?.id);
      }
      await this.initialize();
      await this.filter();
      this.spinnerService.hide();
    } catch (error) {
      console.log("ERROR", error);
    }
  }

  async initialize(){
    if(this.groups.includes('admin') || this.groups.includes('operation')){
      await this.getAllExperts();
    }
    await this.getAllService();
  }

  async getAllService(){
    try {
      const services = await this.service.getAllServicess();
      this.services = services.services;
    }
    catch { }
  }

  async getAllExperts(){
    try {
      this.experts = await this.expertService.getAllActiveExpertsForDelivery().then(res => res.experts);
    }
    catch { }
  }

  handleFilterForm(){
    this.transactionFilterForm = new FormGroup({
      'Transactions.id': new FormControl(''),
      'Delivery.id': new FormControl(''),
      'Transactions.transactionPaymentStatus': new FormControl(''),
      'Transactions.type': new FormControl(''),
      'Transactions.transactionId': new FormControl(''),
      /*
      'Transactions.createdAt': new FormControl(''),
      'Transactions.createdAt_From': new FormControl(''),
      'Transactions.createdAt_To': new FormControl(''),
      */
      'Transactions.debitAt': new FormControl(''),
      'Transactions.debitAt_From': new FormControl(''),
      'Transactions.debitAt_To': new FormControl(''),
      'Transactions.creditAt': new FormControl(''),
      'Transactions.creditAt_From': new FormControl(''),
      'Transactions.creditAt_To': new FormControl(''),
      'Transactions.totalAmount': new FormControl(''),
      'Transactions.totalAmount.operator': new FormControl('equal'),
    });
  }

  async fnReset() {
    this.transactionFilterForm = new FormGroup({
      'Transactions.id': new FormControl(''),
      'Delivery.id': new FormControl(''),
      'Transactions.transactionPaymentStatus': new FormControl(''),
      'Transactions.type': new FormControl(''),
      'Transactions.transactionId': new FormControl(''),
      /*
      'Transactions.createdAt': new FormControl(''),
      'Transactions.createdAt_From': new FormControl(''),
      'Transactions.createdAt_To': new FormControl(''),
      */
      'Transactions.debitAt': new FormControl(''),
      'Transactions.debitAt_From': new FormControl(''),
      'Transactions.debitAt_To': new FormControl(''),
      'Transactions.creditAt': new FormControl(''),
      'Transactions.creditAt_From': new FormControl(''),
      'Transactions.creditAt_To': new FormControl(''),
      'Transactions.totalAmount': new FormControl(''),
      'Transactions.totalAmount.operator': new FormControl('equal'),
    });
  }

  async filter() {

    let filterForm = (new FormGroupToObject()).transform(this.transactionFilterForm);
    this.filtered = {};

    if (filterForm['Transactions.id'])
      this.filtered['Transactions.id'] = filterForm['Transactions.id'];
    if (filterForm['Delivery.id'])
      this.filtered['Delivery.id'] = filterForm['Delivery.id'];
    if (filterForm['Transactions.transactionPaymentStatus'])
      this.filtered['Transactions.transactionPaymentStatus'] = filterForm['Transactions.transactionPaymentStatus'];
    if (filterForm['Transactions.type'])
      this.filtered['Transactions.type'] = filterForm['Transactions.type'];
    if (filterForm['Transactions.transactionId'])
      this.filtered['Transactions.transactionId'] = filterForm['Transactions.transactionId'];
    if (filterForm['Transactions.totalAmount'])
      this.filtered['Transactions.totalAmount'] = { operator: filterForm['Transactions.totalAmount.operator'], values: [filterForm['Transactions.totalAmount']] };

    /*
    if (filterForm['Transactions.createdAt_From'])
      this.filtered['Transactions.createdAt'] = { operator: 'moreThanOrEqual', values: [filterForm['Transactions.createdAt_From']] };
    if (filterForm['Transactions.createdAt_To'])
      this.filtered['Transactions.createdAt'] = { operator: 'lessThan', values: [filterForm['Transactions.createdAt_To']] };
    if (filterForm['Transactions.createdAt_From'] && filterForm['Transactions.createdAt_To'])
      this.filtered['Transactions.createdAt'] = { operator: 'between', values: [filterForm['Transactions.createdAt_From'], filterForm['Transactions.createdAt_To']] };
    */

    if (filterForm['Transactions.debitAt_From']) {
      const debitAtFrom = filterForm['Transactions.debitAt_From'] + " 00:00:00";
      this.filtered['Transactions.debitAt'] = { operator: 'moreThanOrEqual', values: [debitAtFrom] };
    }

    if (filterForm['Transactions.debitAt_To']) {
      const debitAtTo = filterForm['Transactions.debitAt_To'] + " 23:59:59";
      this.filtered['Transactions.debitAt'] = { operator: 'lessThanOrEqual', values: [debitAtTo] };
    }

    if (filterForm['Transactions.debitAt_From'] && filterForm['Transactions.debitAt_To']) {
      const debitAtFrom = filterForm['Transactions.debitAt_From'] + " 00:00:00";
      const debitAtTo = filterForm['Transactions.debitAt_To'] + " 23:59:59";
      this.filtered['Transactions.debitAt'] = { operator: 'between', values: [debitAtFrom, debitAtTo] };
    }

    if (filterForm['Transactions.creditAt_From']) {
      const creditAtFrom = filterForm['Transactions.creditAt_From'] + " 00:00:00";
      this.filtered['Transactions.creditAt'] = { operator: 'moreThanOrEqual', values: [creditAtFrom] };
    }

    if (filterForm['Transactions.creditAt_To']) {
      const creditAtTo = filterForm['Transactions.creditAt_To'] + " 23:59:59";
      this.filtered['Transactions.creditAt'] = { operator: 'lessThanOrEqual', values: [creditAtTo] };
    }

    if (filterForm['Transactions.creditAt_From'] && filterForm['Transactions.creditAt_To']) {
      const creditAtFrom = filterForm['Transactions.creditAt_From'] + " 00:00:00";
      const creditAtTo = filterForm['Transactions.creditAt_To'] + " 23:59:59";
      this.filtered['Transactions.creditAt'] = { operator: 'between', values: [creditAtFrom, creditAtTo] };
    }



    await this.loadTransactions();
  }

  async loadTransactions(limit?: number, page?: number, order?: {}){
    try {
      let filterForm = (new FormGroupToObject()).transform(this.transactionFilterForm);
      this.page = page || parseInt(this.route.snapshot.queryParamMap.get('page')) || this.defaultPage;
      this.limit = limit || parseInt(this.route.snapshot.queryParamMap.get('limit')) || this.defaultLimit;
      this.order = order || JSON.parse(this.route.snapshot.queryParamMap.get('order')) || this.defaultOrder;

      let transactions = await this.transactionService.getTransactions(this.selectedExpert?.id, this.page, this.limit, this.order, this.filtered);
      console.log("transactions", transactions)
      this.transactions = transactions.transactions;
      this.count = transactions.count;
      this.maxPage = Math.ceil(this.count / this.limit);
    } catch (error) {
      
    }
  }

  public groupWhitelisted(groups: string | string[]): boolean {
    if (!Array.isArray(groups))
      return this.groups.includes(groups);
    for (let group of groups)
      if (this.groups.includes(group))
        return true;
    return false;
  }

  async navigate(event) {
    await this.loadTransactions(event.limit, event.page, this.order);
  }

  public orderIcon(attribute: string | string[]): string {
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    if(this.order){
      for (let attr of attribute) {
        switch (this.order[attr]) {
          case 'ASC':
            return 'fa-sort-up';
          case 'DESC':
            return 'fa-sort-down';
          default:
            return 'fa-sort';
        }
      }
    }
  }

  public navigateOrder(attribute: string | string[]) {
    if(this.order){
      delete this.order['Transactions.updatedAt'];
    }
    attribute = Array.isArray(attribute) ? attribute : [attribute];
    if(this.order){
      for (let attr of attribute) {
        switch (this.order[attr]) {
          case 'ASC':
            this.order[attr] = 'DESC';
            break;
          case 'DESC':
            this.order[attr] = undefined;
            break;
          default:
            this.order = {}
            this.order[attr] = 'ASC';
            break;
        }
      }
    }

    this.navigatePage(this.limit, this.page, { order: this.order });
  }

  navigatePage(limit: number, page: number, args: {} = {}) {
    args = this.escapeQueryStringParams(args);
    const previousArgs = Object.keys(args).length ? {} : this.route.snapshot.queryParams;
    const newParams = { ...previousArgs };
    newParams[`limit`] = limit;
    newParams[`page`] = page;
    this.router.navigate(this.route.snapshot.url.map(u => u.path), { queryParams: { ...newParams, ...args } }).then(data => {
      this.loadTransactions();
    });
  }

  private escapeQueryStringParams(args: {} = {}): {} {
    Object.keys(args).forEach(key => {
      switch (Object.prototype.toString.call(args[key])) {
        case '[object Number]':
        case '[object String]':
          // Keep the same
          break;
        case '[object Array]':
        case '[object Object]':
          // Convert to JSON
          args[key] = JSON.stringify(args[key]);
          break;
        default:
          // Not supported type
          delete args[key];
          break;
      }
    });
    return args;
  }

  transactionStatusClass(transaction: any) {
    if(transaction.transactionPaymentStatus === DeliveryPaymentStatus.toBePaid) {
      return 'to-be-paid-chip';
    } else if(transaction.transactionPaymentStatus === DeliveryPaymentStatus.paid) {
      return 'paid-chip';
    }
  }

  showFinancialStatus(transaction: any) {
    if(transaction.transactionPaymentStatus === DeliveryPaymentStatus.toBePaid) {
      return 'TOBEPAID'
    } else if(transaction.transactionPaymentStatus === DeliveryPaymentStatus.paid) {
      return 'PAID';
    }
  }

  async handleExpertChange(expertId: any){
    try {
      this.spinnerService.show();
      this.transactions = [];
      this.selectedExpert = this.experts.find((expert) => {
        return expert?.id == expertId;
      });
      this.selectedExpertId = this.selectedExpert?.id;
      this.totalCreditAmount  = (await this.transactionService.getCreditAmount(Number(expertId))).amount || 0;
      await this.loadTransactions();
      this.spinnerService.hide();
    } catch (error) {
    }
  }
  
}
